import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import {Product} from "./Product";
import Additive from "./Additive";
import Selective from "./Selective";
import {Variant} from "./Variant";

@usingJsonToModelConvertor
export default class OrderItem extends Model{

    @fromJsonObject({key: 'id'})
    public id! : number;

    @fromJsonObject({key: 'order_id'})
    public orderId! : number;

    @fromJsonObject({key: 'count'})
    public count! : number;

    @fromJsonObject({key: 'name'})
    public name! : string;

    @fromJsonObject({key: 'price'})
    public price! : number;

    @fromJsonObject({key: 'packing_price'})
    public packingPrice! : number|null;

    @fromJsonObject({key: 'product', modelClass: Product})
    public product! : Product;

    @fromJsonObject({key: 'variant', modelClass: Variant})
    public variant! : Variant|null;

    @fromJsonObject({key: 'additives', modelClass: Additive, isArray: true})
    public additives! : Additive[];

    @fromJsonObject({key: 'selective', modelClass: Selective})
    public selective! : Selective|null;

}
